export default __webpack_public_path__ + "static/hypershift_screen_2-de04a7c9739a65952779bee3f5e656ba.svg";